var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"active":_vm.active},on:{"close":_vm.close}},[_c('div',{staticClass:"modal-confirm"},[_c('div',{staticClass:"confirm-title"},[_vm._v("Verifique seu e-mail e confirme a mudança da sua senha!")]),_c('Button',{attrs:{"type":"primary","title":"Ok!"},on:{"click":_vm.close}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }